import React from "react";
import '../index.css';
import TopBar from "../components/TopBar";
import SideBar from "../components/SideBar";
import ParentFee from "../pages/ParentFee";

function ParentFeeLayout(){
    return (
    <div className="d-flex flex-column" id="kt_app_root">
    

        {/* Main Content Area */}
        <div className="flex-grow-1">
            <ParentFee />
        </div>
      
    </div>

    );
}

export default ParentFeeLayout;